import React from 'react';
import PropTypes from 'prop-types';

function ApplePayIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="36"
      viewBox="0 0 68 36"
      className={className}
    >
      <path d="M17.6 10.5a4 4 0 0 0 1-2.9 4 4 0 0 0-3.6 4.1c1 .1 2-.5 2.6-1.2m1 1.4c-1.5 0-2.8.8-3.5.8-.7 0-1.8-.7-3-.7-1.4 0-2.8.9-3.6 2.2-1.6 2.7-.4 6.8 1.1 9 .8 1 1.6 2.3 2.8 2.2 1.1 0 1.6-.7 3-.7 1.3 0 1.7.7 2.9.7s2-1 2.7-2.2c.9-1.2 1.2-2.4 1.2-2.5 0 0-2.3-1-2.3-3.6 0-2.3 1.8-3.3 1.9-3.4a4.2 4.2 0 0 0-3.3-1.8M31.3 8.9c3.2 0 5.4 2.2 5.4 5.4s-2.3 5.4-5.5 5.4h-3.5v5.6H25V8.9h6.2zm-3.6 8.6h3c2.1 0 3.4-1.2 3.4-3.2 0-2.1-1.3-3.3-3.5-3.3h-3v6.5zm9.7 4.4c0-2.1 1.6-3.4 4.4-3.5l3.3-.2v-1c0-1.3-.9-2-2.4-2-1.4 0-2.3.6-2.5 1.7h-2.3c0-2.2 2-3.8 4.9-3.8 3 0 4.8 1.5 4.8 4v8.2h-2.4v-2a4.3 4.3 0 0 1-3.8 2.2c-2.4 0-4-1.5-4-3.6zm7.7-1v-1l-3 .2c-1.4 0-2.2.7-2.2 1.7s.8 1.8 2.1 1.8c1.8 0 3.1-1.2 3.1-2.8zm4.7 8.8v-2h.8c1.1 0 1.7-.4 2.1-1.6l.2-.8-4.3-12h2.7l3 9.8 3-9.8H60L55.5 26c-1 3-2.2 3.9-4.7 3.9h-1z" />
    </svg>
  );
}

ApplePayIcon.propTypes = {
  className: PropTypes.string,
};

module.exports = ApplePayIcon;
